import * as Sentry from '@sentry/react';
import type { QueryClient } from '@tanstack/react-query';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';

import { ErrorBoundary } from './components/ui/error';
import Callback, { CallbackLoader } from './routes/auth/callback';
import { Login, LoginLoader } from './routes/auth/login';
import { Register } from './routes/auth/register';
import Home from './routes/home';
import LandingPage from './routes/landing-page';
import Layout, { LayoutLoader } from './routes/layout';
import VendorDetail from './routes/vendor/$id';

const sentryCreateBrowserRouter =
	Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const createAppRouter = (queryClient: QueryClient) => {
	const routes: RouteObject[] = [
		{
			index: true,
			Component: LandingPage
		},
		{
			Component: Layout,
			loader: LayoutLoader(queryClient),
			errorElement: <ErrorBoundary />,
			id: 'root',
			children: [
				{
					path: '/home',
					Component: Home
				},
				{
					path: '/vendor/:id',
					Component: VendorDetail
				}
			]
		},
		{
			path: '/register',
			Component: Register,
			loader: LoginLoader
		},
		{
			path: '/login',
			Component: Login,
			loader: LoginLoader
		},
		{
			path: '/account/login-callback',
			Component: Callback,
			loader: CallbackLoader
		}
	];

	return sentryCreateBrowserRouter(routes);
};

export default createAppRouter;
